"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeeMoreJobClickViewDetailsSuccessEvent = exports.SeeMoreJobClickBookmarkSuccessEvent = exports.SeeMoreJobClickPleaseSubmitSuccessEvent = exports.SeeMoreRecommendJobsSuccessEvent = exports.SeeMoreJobLandingSuccessEvent = void 0;
const base_event_1 = require("./base.event");
class SeeMoreJobLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'SEE_MORE_JOBS_LANDING_SUCCESS';
    }
}
exports.SeeMoreJobLandingSuccessEvent = SeeMoreJobLandingSuccessEvent;
class SeeMoreRecommendJobsSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'SEE_MORE_JOBS_RECOMMEND_JOBS_SUCCESS';
    }
}
exports.SeeMoreRecommendJobsSuccessEvent = SeeMoreRecommendJobsSuccessEvent;
class SeeMoreJobClickPleaseSubmitSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'SEE_MORE_JOBS_CLICK_PLEASE_SUBMIT_SUCCESS';
    }
}
exports.SeeMoreJobClickPleaseSubmitSuccessEvent = SeeMoreJobClickPleaseSubmitSuccessEvent;
class SeeMoreJobClickBookmarkSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'SEE_MORE_JOBS_CLICK_BOOKMARK_SUCCESS';
    }
}
exports.SeeMoreJobClickBookmarkSuccessEvent = SeeMoreJobClickBookmarkSuccessEvent;
class SeeMoreJobClickViewDetailsSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'SEE_MORE_JOBS_CLICK_VIEW_DETAILS_SUCCESS';
    }
}
exports.SeeMoreJobClickViewDetailsSuccessEvent = SeeMoreJobClickViewDetailsSuccessEvent;
//# sourceMappingURL=popular-job.events.js.map